import { CustomProductDescriptionProps } from './types';

const CustomProductDescription = ({ testid, description }: Readonly<CustomProductDescriptionProps>) =>
  description ? (
    <div data-testid={testid}>
      <p>Custom Build</p>
      <p>{description.join(' • ')}</p>
    </div>
  ) : null;

export default CustomProductDescription;
